import { includedProjectsUrl } from "@Services/dataManager";
import {
  minimiseFileSync as minimiseFileSyncAction,
  maximiseFileSync as maximiseFileSyncAction,
  closeFileSync as closeFileSyncAction,
  setFileSyncData as setFileSyncDataAction,
  fileSyncMapperLoading,
  fileSyncMapperLoaded,
  fileSyncMapperClear,
} from "../reducers/fileSync";
import axiosWrapper from "@Services/axiosWrapper";
import { getBackendUrl } from "@Utils";
import _ from "lodash";

export const minimiseFileSync = () => minimiseFileSyncAction();

export const maximiseFileSync = () => maximiseFileSyncAction();

export const closeFileSync = () => closeFileSyncAction();

export const setFileSyncData = (data) => setFileSyncDataAction(data);

export const fetchFileSyncMapperData =
  ({ moduleName, moduleId }) =>
  async (dispatch, getState) => {
    const { fileSyncMapperState } = getState();

    if (
      _.get(fileSyncMapperState, `${moduleName}.${moduleId}.isLoading`, false) ||
      _.get(fileSyncMapperState, `${moduleName}.${moduleId}.isLoaded`, false)
    ) {
      return;
    }

    dispatch(fileSyncMapperLoading({ moduleName, moduleId }));

    try {
      let data;
      if (moduleName == "project") {
        const response = await axiosWrapper.post(includedProjectsUrl, {
          value: {
            where: [
              {
                isComplex: false,
                field: "_id",
                operator: "equal",
                value: moduleId,
                ignoreCase: false,
              },
            ],
          },
        });
        data = response.data.result[0];
      } else if (moduleName == "space") {
        const response = await axiosWrapper.get(`${getBackendUrl()}/spaces/getSpaceById/${moduleId}`);
        if (response.data.status) {
          data = response.data.data;
        } else {
          fileSyncMapperClear({ moduleName, moduleId });
        }
      } else {
        const response = await axiosWrapper.post(`${getBackendUrl()}/fileSystemServer/getHierarchyIdDetails`, {
          hierarchyId: moduleId,
        });
        if (response.data.status) {
          data = response.data.data;
        } else {
          fileSyncMapperClear({ moduleName, moduleId });
        }
      }
      dispatch(fileSyncMapperLoaded({ moduleName, moduleId, data }));
    } catch (error) {
      fileSyncMapperClear({ moduleName, moduleId });
      console.error("Error fetching user tag data:", error);
    }
  };
